var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupplyManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #667085;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m46.13,11.82c3.34,0,6.05,2.71,6.05,6.05v28.25c0,3.34-2.71,6.05-6.05,6.05h-22.2c-3.34,0-6.05-2.71-6.05-6.05v-6.05c0-1.11.9-2.02,2.02-2.02s2.02.9,2.02,2.02v4.04c0,2.23,1.81,4.04,4.04,4.04h18.16c2.23,0,4.04-1.81,4.04-4.04v-24.22c0-2.23-1.81-4.04-4.04-4.04h-18.16c-2.23,0-4.04,1.81-4.04,4.04v4.04c0,1.11-.9,2.02-2.02,2.02s-2.02-.9-2.02-2.02v-6.05c0-3.34,2.71-6.05,6.05-6.05h22.2Zm-13.88,8.66c-.79-.79-2.07-.79-2.85,0-.79.79-.79,2.07,0,2.85l5.81,5.81H13.84c-1.11,0-2.02.9-2.02,2.02s.9,2.02,2.02,2.02h21.51l-5.95,5.95c-.79.79-.79,2.07,0,2.85.79.79,2.07.79,2.85,0l8.56-8.56c.18-.18.32-.39.42-.61.52-.36.87-.97.87-1.66,0-.73-.39-1.38-.98-1.73-.08-.14-.18-.27-.3-.39l-8.56-8.56Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplyManager);
export default __webpack_public_path__ + "static/media/supplyManager.936ac4cb707ce28e02e7ee4fa8e4d6e1.svg";
export { ForwardRef as ReactComponent };